import KumovegaError from "./KumovegaError";

export default class MissingConfigurationError extends KumovegaError {}
